import React from 'react'
import axios from "axios/index"
import MDSpinner from "react-md-spinner"

export default class FullOffer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        if (this.props.ext_offer_id) {
            axios.get(`/external_cars/${this.props.ext_offer_id}/rental_fees.json?${this.props.qs}&item_id=${this.props.offer_id}`)
            .then((res) => {
                this.setState({...res.data, loading: false})
            })
        }
        else {
            axios.get(`/rental_cars/${this.props.offer_id}/rental_fees.json?${this.props.qs}&model=${this.props.model_id}`)
            .then((res) => {
                this.setState({...res.data, loading: false})
            })
        }
    }


    render() {
        if (this.state.loading) {
            return (
                <div style={{textAlign: 'center'}}>
                    <MDSpinner/>
                </div>
            )
        }
        const {fees, insurances: ins, dislocation, delivery} = this.state
        return (
            <div className={'mb-3 pb-3'} style={{borderBottom: '1px solid #eeeeee'}}>
                {!this.state.loading &&
                <React.Fragment>
                    <div className={'alert-info px-2 mb-1'}>{this.props.t.fees_title}:</div>
                    {fees &&
                    <div className='mb-1 pl-2'>
                        {fees.map((fee, idx) => <div key={idx} className={'mb-1'}>
                            <span className={'font-weight-600'}>{this.props.t[fee.name] || `${fee.name} !`} </span>
                            {fee.value}&euro;
                        </div>)}
                    </div>
                    }
                    {(dislocation && +dislocation) > 0 &&
                    <div className='mb-1 pl-2'>
                        <span className={'font-weight-600'}>
                            {this.props.ext_offer_id ? this.props.t.dislocation : this.props.t.car_dislocation} {this.state.dislocation_to}
                        </span>{' '}
                        {dislocation}&euro;
                    </div>
                    }
                    {(delivery && +delivery) > 0 &&
                    <div className='mb-1 pl-2'>
                        <span className={'font-weight-600'}>{this.props.t.car_delivery} {this.state.delivery_from} </span>
                        {delivery}&euro;
                    </div>
                    }
                    {fees && fees.length === 0 && !dislocation && !delivery &&
                    <div className='mb-1 pl-2 font-weight-600'>
                        0 &euro;
                    </div>
                    }
                    {ins &&
                    <div className='mb-2 mt-3'>
                        <div className={'alert-info px-2 mb-1'}>{this.props.t.insurances_title}:</div>
                        {(ins.d1 > 0 || ins.i1 > 0) &&
                        <div className={'pl-2 mb-1'}>
                            <span style={{color: 'orange'}}
                                  className="font-weight-600">{this.props.t.i_no_prot}</span>{' '}
                            {ins.i1 > 0 && <span>{ins.i1}&euro;/{this.props.t.i_day} </span>}
                            {this.props.t.i_is} {ins.d1}&euro;
                        </div>
                        }
                        {(ins.d2 > 0 || ins.i2 > 0) > 0 &&
                        <div className={'pl-2 mb-1'}>
                            <span className={'text-success font-weight-600'}>{this.props.t.i_premium}</span>{' '}
                            {ins.i2 > 0 && <span>{ins.i2}&euro;/{this.props.t.i_day} </span>}
                            {this.props.t.i_less} {ins.d2}&euro;
                        </div>
                        }
                        {(ins.d3 > 0 || ins.i3 > 0) &&
                        <div className={'pl-2'}>
                            <span className={'text-primary font-weight-600'}>{this.props.t.i_full}</span>{' '}
                            {ins.i3 > 0 && <span>{ins.i3}&euro;/{this.props.t.i_day} </span>}
                            {this.props.t.i_less} {ins.d3}&euro;
                        </div>
                        }
                    </div>
                    }
                </React.Fragment>
                }
            </div>
        )
    }


}
